import tp_img1 from "@/assets/images/LarryGossen_TP.png";
import tp_img2 from "@/assets/images/Sandor_TP.png";
import tp_img3 from "@/assets/images/RozaliaPap_TP.png";
import tp_img4 from "@/assets/images/Robert_TP.png";
import tp_img5 from "@/assets/images/ToddG_TP.png";
import tp_img6 from "@/assets/images/Phil_TP.png";
import tp_img7 from "@/assets/images/Neil_TP.png";

export const SUPABASE_OPERATORS = {
  EQ: "eq",
  NEQ: "neq",
  GT: "gt",
  GTE: "gte",
  LT: "lt",
  LTE: "lte",
  IN: "in",
  NIN: "not.in",
  NOT_IS: "not.is",
};

export const INVESTOR_ACTIVITY_TYPES = {
  step_completed: { status: "Step Completed", defaultMessage: (step) => `${step} completed` },
  substep_completed: {
    status: "Substep Completed",
    defaultMessage: (step, substep) => `${step} — ${substep} completed`,
  },
  validation_failure: {
    status: "Validation Failed",
    defaultMessage: (step) => `Validation failed on ${step}`,
  },
  investment_created: {
    status: "Investment Created",
    defaultMessage: () => "New investment created",
  },
  investment_updated: {
    status: "Investment Updated",
    defaultMessage: () => "Investment updated",
  },
  investment_signed: {
    status: "Investment Signed",
    defaultMessage: () => "Investment signed",
  },
  investment_change_confirmed: {
    status: "Investment Change Confirmed",
    defaultMessage: () => "Mid-flow investment changes confirmed",
  },
  investment_change_discarded: {
    status: "Investment Change Discarded",
    defaultMessage: () => "Mid-flow investment changes discarded",
  },
  defaultMessage: (step, substep, details) => {
    const parts = [];
    if (details?.amount) {
      parts.push(`amount: ${details.amount.old} → ${details.amount.new}`);
    }
    if (details?.offering) {
      parts.push(
        `rate: ${details.offering.old?.interest_rate}% → ${details.offering.new?.interest_rate}%`
      );
    }
    if (details?.is_compounded) {
      parts.push(`compounding: ${details.is_compounded.old} → ${details.is_compounded.new}`);
    }
    const summary = parts.length ? ` (${parts.join("; ")})` : "";
    return `Investor changed investment metrics at ${step}/${substep}${summary}`;
  },
  // Add more as needed:
  // document_uploaded, accreditation_submitted, funding_selected, etc.
};

export const TRUST_PILOT_REVIEWS = [
  {
    name: "Larry G.",
    quote: "Excellent Communications",
    link: "https://www.trustpilot.com/reviews/66b278dbbd1383461051c899",
    img: tp_img1,
    full_text:
      "The communications with PCG staff was very clear and timely. They consistently followed up with us to ensure we had what we needed to make the transfers happen. It was a seamless process. I felt very confident in our investment choices.",
  },
  {
    name: "Sandor",
    quote: "I have been an investor with PCG for 2 months",
    link: "https://www.trustpilot.com/reviews/6306a0917f7a8621ee48b041",
    img: tp_img2,
    full_text:
      "I have been an investor with PCG for 2 months, and have received 2 monthly interest payments at 0.75% monthly rate. I decided to buy more bonds because the stock market delivers more and more frustration contrary to the 9% yearly interest coming from PCG. Whenever I needed help my #1 person to turn to has been Matt Willer. He deserves a 6 star rating. I wish PCG could clone him for every department they have. His knowledge and attitude guarantee long term success for the company.",
  },
  {
    name: "Rozalia P.",
    quote: "Happy to have found this great company",
    link: "https://www.trustpilot.com/reviews/654131959c4b85f55a13dfed",
    img: tp_img3,
    full_text:
      "It's been a year now since I decided to invest in this very intriguing company. It took me 6 months to research them before making the step. I find Phoenix Capital Group LLC of high integrity, easy to connect with, and monthly payments are on the clock every time. Thank you to the whole team, especially Matt. Rozalia P.",
  },
  {
    name: "Robert",
    quote: "Phoenix Capital Group lives up to their word!",
    link: "https://www.trustpilot.com/reviews/63768365252cba2c02dbe723",
    img: tp_img4,
    full_text:
      "Lately I had been dissatisfied with the performance of the stock market this year and my investment kept shrinking. I was hoping to find something better and looked at several opportunities. When I saw Phoenix Capital Group and its offerings, I signed up for the webinar right away. We were in the middle of selling our home, so I didn't jump on the opportunity as fast as I wanted, and we also had some questions. Matt answered them all the next day through a personal email video. The sale of our house and the move several states away took a bit longer than I hoped, but after we got all settled in two months later, I made a substantial investment, and we got our first monthly check within the first two weeks. Everything went exactly as Matt and Cameron had said, and we couldn't be happier. Looking forward to these monthly checks and some future investing with Phoenix Capital Group.",
  },
  {
    name: "Todd G.",
    quote: "A Class Act",
    link: "https://www.trustpilot.com/reviews/65a7439a4e16a27b42fa540f",
    img: tp_img5,
    full_text:
      "From the start, the team was extremely courteous and responsive to all my questions and concerns about moving my IRA funds and setting up an account with Phoenix. Those human to human skills are extremely meaningful to me, especially in a numbers-are-important environment. I was equally touched by the thoughtful and beautiful Yeti cup for Christmas last month. It was an unexpected, classy gesture and I was hoping I'd get a chance to thank the team for creating and continuing such a welcoming, genial atmosphere with your investors. It's really refreshing!",
  },
  {
    name: "Phil N.",
    quote: "They passed my review",
    link: "https://www.trustpilot.com/reviews/654132b3f59b42212d508525",
    img: tp_img6,
    full_text:
      "Very pleased with the level of investor service provided. A year ago when I was a new/prospective investor with Phoenix I wore them out with questions as I worked to understand this alternate investment, which was new to me. Being a CPA, I wanted to challenge myself to clearly understand the underlying risks, and to identify any issues lurking under the surface. To the Company's benefit, they showed great patience and had knowledgeable resources available to answer all of my questions.",
  },
  {
    name: "Neil M.",
    quote: "Peace of Mind with Phoenix Capital Group",
    link: "https://www.trustpilot.com/reviews/646551162c3be2ffd7e986cf",
    img: tp_img7,
    full_text:
      "I have been investing for 20 years across a variety of different investments. Some have been good and some not so good. I found PCG on Facebook and thought I was do some research. They sounded good but don't they all when they are touting for investment. I then sat through one of their quarterly updates and I was surprised with the transparency and openness when answering questions, so I took the plunge. Its now 10 months on and I am thrilled with my investments. I have three bonds and getting ready to invest in another. They do what they say and deliver on a good return.",
  },
];

export const CHART_OPTIONS = {
  plugins: {
    title: {
      display: false,
      text: "Distribution Amounts",
      align: "start",
      font: { size: 14 },
    },
    legend: {
      display: true,
    },
    tooltip: {
      callbacks: {
        label: function (tooltipItem) {
          const value = tooltipItem.raw;
          return (
            "$" +
            Number(value)
              .toFixed(2)
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          );
        },
      },
    },
  },
  scales: {
    x: {
      stacked: true,
      ticks: {
        display: true,
      },
      grid: { display: false },
    },
    y: {
      stacked: true,
      ticks: {
        display: false,
      },
      title: {
        display: true,
        text: "Valuation",
        font: { size: 14 },
        color: "#6a7c8c",
      },
      grid: { display: true },
    },
  },
  responsive: true,
  maintainAspectRatio: false,
};

export const JOINT_TEMPLATE = {
  first_name: "",
  last_name: "",
  phone: "",
  email: "",
  date_of_birth: "",
  ssn: "",
  occupation: "",
  employer: "",
  country: "United States",
  city: "",
  street1: "",
  street2: "",
  state: "",
  zip_code: "",
  type: "Joint",
  id_info: {},
};

export const ENTITY_TEMPLATE = {
  name: "",
  phone: "",
  email: "",
  ein: "",
  entity_type: "",
  country: "United States",
  city: "",
  street1: "",
  street2: "",
  state: "",
  zip_code: "",
  type: "Entity",
};

export const NEW_BENEFICIAL_OWNER_TEMPLATE = {
  first_name: "",
  last_name: "",
  date_of_birth: "",
  ssn: "",
  country: "United States",
  state: "",
  street1: "",
  street2: "",
  city: "",
  zip_code: "",
  type: "Beneficial Owner",
  id_info: {},
};

export const AVAILABLE_COUNTRIES = ["United States", "Canada"];

export const ALL_50_STATES = [
  { name: "Alabama", value: "AL" },
  { name: "Alaska", value: "AK" },
  { name: "Arizona", value: "AZ" },
  { name: "Arkansas", value: "AR" },
  { name: "California", value: "CA" },
  { name: "Colorado", value: "CO" },
  { name: "Connecticut", value: "CT" },
  { name: "Delaware", value: "DE" },
  { name: "District of Columbia", value: "DC" },
  { name: "Florida", value: "FL" },
  { name: "Georgia", value: "GA" },
  { name: "Hawaii", value: "HI" },
  { name: "Idaho", value: "ID" },
  { name: "Illinois", value: "IL" },
  { name: "Indiana", value: "IN" },
  { name: "Iowa", value: "IA" },
  { name: "Kansas", value: "KS" },
  { name: "Kentucky", value: "KY" },
  { name: "Louisiana", value: "LA" },
  { name: "Maine", value: "ME" },
  { name: "Maryland", value: "MD" },
  { name: "Massachusetts", value: "MA" },
  { name: "Michigan", value: "MI" },
  { name: "Minnesota", value: "MN" },
  { name: "Mississippi", value: "MS" },
  { name: "Missouri", value: "MO" },
  { name: "Montana", value: "MT" },
  { name: "Nebraska", value: "NE" },
  { name: "Nevada", value: "NV" },
  { name: "New Hampshire", value: "NH" },
  { name: "New Jersey", value: "NJ" },
  { name: "New Mexico", value: "NM" },
  { name: "New York", value: "NY" },
  { name: "North Carolina", value: "NC" },
  { name: "North Dakota", value: "ND" },
  { name: "Ohio", value: "OH" },
  { name: "Oklahoma", value: "OK" },
  { name: "Oregon", value: "OR" },
  { name: "Pennsylvania", value: "PA" },
  { name: "Puerto Rico", value: "PR" },
  { name: "Rhode Island", value: "RI" },
  { name: "South Carolina", value: "SC" },
  { name: "South Dakota", value: "SD" },
  { name: "Tennessee", value: "TN" },
  { name: "Texas", value: "TX" },
  { name: "Utah", value: "UT" },
  { name: "Vermont", value: "VT" },
  { name: "Virginia", value: "VA" },
  { name: "Washington", value: "WA" },
  { name: "West Virginia", value: "WV" },
  { name: "Wisconsin", value: "WI" },
  { name: "Wyoming", value: "WY" },
];

export const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const INVESTMENT_TYPES = [
  {
    name: "Individual",
    icon: "User",
    description:
      "An individual account is an investment account that belongs only to you. No one else has rights or ownership over it.",
  },
  {
    name: "Joint",
    icon: "Users",
    description:
      "A joint account is an investment account that belongs to you and someone else. You can both make decisions over the assets. Examples of a joint account include spouse or partner.",
  },
  {
    name: "Entity",
    icon: "BriefcaseBusiness",
    description:
      "An entity account is an investment account that belongs to an organization or structure other than an individual or joint. This includes partnerships, corporations, trusts, etc. The structure of the entity dictates who has rights or ownership over it.",
  },
  {
    name: "IRA",
    icon: "BriefcaseBusiness",
    description:
      "An IRA is an Individual Retirement Account that provides tax advantages for your retirement savings. You can invest with Phoenix Energy through an existing Traditional, SEP, Self-Directed, Roth, or other IRA.",
  },
];

export const ACCREDITATION_STATUS_QUESTIONS_ANSWERS = [
  {
    field_name: "investment_objective",
    question: "Which of the following best describes your current financial status?",
    answers: [
      "I have a gross income of $70k, and a liquid net worth of $70k or more",
      "My liquid net worth is $250k",
      "None of these apply to me",
    ],
  },
];

export const ESIGNATURE_OPTIONS = [
  {
    type: "investor_acknowledgement_and_representation",
    options: [
      "I have an individual net worth, or joint net worth with my spouse (or spousal equivalent), of more than $1 million excluding primary residence (see the Memorandum under “SUITABILITY STANDARDS”) but including home furnishings and personal automobiles.",
      "I have individual income in excess of $200,000 or joint income with my spouse (or spousal equivalent) in excess of $300,000, in each of the two most recent years and I have a reasonable expectation of reaching the same income level in the current year.",
      "I am a holder in good standing of one or more of certain professional certifications or designations, including the Financial Industry Regulatory Authority, Inc. Licensed General Securities Representative (Series 7), Licensed Investment Adviser Representative (Series 65), or Licensed Private Securities Offerings Representative (Series 82) certifications.",
      "I am one or more of the following: director, officer, or general partner of the Company or person serving in a similar capacity, or any director, officer, general partner, or person serving in a similar capacity of the general partner of the Company.",
    ],
  },
  {
    type: "entity_acknowledgements",
    options: [
      "Any entity in which all of the equity owners are accredited investors.",
      "Any entity with investments (as defined in Section 2a51-1(b) of the Investment Company Act) exceeding $5,000,000, not formed for the specific purpose of acquiring Bonds.",
      "Any investment adviser registered under the Investment Advisers Act of 1940, as amended (the “Advisers Act”), or an exempt reporting adviser (as defined in Section 203(l) or Section 203(m) of the Advisers Act), or a state-registered investment adviser.",
      "Any trust, with total assets over $5,000,000, not formed for the specific purpose of acquiring Bonds and whose purchase is directed by a person who has such knowledge and experience in financial and business matters that he or she is capable of evaluating the merits and risks of an investment in the Bonds as described in Rule 506(b)(2)(ii) under the Securities Act.",
      "Any family client of a family office with total assets of at least $5,000,000, not formed for the specific purpose of acquiring Bonds and whose purchase is directed by a person who has such knowledge and experience in financial and business matters that the family office is capable of evaluating the merits and risks of an investment in Bonds as described in Section 202(a)(11)(G)-1(b) under the Advisers Act.",
      "Any broker-dealer registered under Section 15 of the Securities Exchange Act of 1934, as amended.",
      "Any investment company registered under the Investment Company Act or a business development company (as defined in Section 2(a)(48) of the Investment Company Act).",
      "Any small business investment company licensed by the Small Business Administration under Section 301(c) or (d) or the Small Business Investment Act of 1958, as amended.",
      "Any rural business investment company (as defined in Section 384A of the Consolidated Farm and Rural Development Act).",
      "Any employee benefit plan within the meaning of ERISA, if the investment decision is made by a plan fiduciary (as defined in Section 3(21) of ERISA), which is either a bank, savings and loan association, insurance company, or registered investment advisor, or if such employee benefit plan has total assets over $5,000,000 or, if a self-directed plan, with investment decisions made solely by persons who are accredited investors.",
      "Any private business development company (as defined in Section 202(a)(22) of the Advisers Act).",
      "Any bank as defined in Section 3(a)(2) of the Securities Act, any savings and loan association or other institution as defined in Section 3(a)(5)(A) of the Securities Act whether acting in its individual or fiduciary capacity, or any insurance company as defined in Section 2(13) of the Securities Act.",
      "Any plan established and maintained by a state, its political subdivisions, or any agency or instrumentality of a state or its political subdivisions, for the benefit of its employees, if such plan has total assets of more than $5,000,000.",
      "Any organization described in Code Section 501(c)(3), corporation, Massachusetts or similar business trust, partnership, or limited liability company, not formed for the specific purpose of acquiring Bonds, with total assets over $5,000,000.",
    ],
  },
  {
    type: "benefit_plan_investor",
    options: [
      "The entity is purchasing the Bonds with funds that constitute, directly or indirectly, the assets of a Benefit Plan Investor (defined below). The entity hereby represents and warrants that its investment in the Company: (i) does not violate and is not otherwise inconsistent with the terms of any legal document constituting or governing the employee benefit plan; (ii) has been duly authorized and approved by all necessary parties; and (iii) is in compliance with all applicable laws.",
      "The entity is not purchasing the Bonds with funds that constitute, directly or indirectly, the assets of a “Benefit Plan Investor” (defined below).",
    ],
  },
];

export const ACCREDITATION_QUALIFIERS = [
  "A letter from CPA, Attorney, or Financial Professional with an active Series 7, Series 65, or Series 82 license.",
  "Proof of assets worth more than $1 million by reviewing specific types of documentation dated within the last 90 days, such as bank statements, brokerage statements, certificates of deposit, or tax assessments.",
  "Individual - Proof of income for 2 years of at least $200,000 by reviewing copies of any Internal Revenue Service form that reports income, such as Form W-2, Form 1099, Schedule K-1 of Form 1065, or a filed Form 1040.",
  "Joint - Proof of income for 2 years of at least $300,000 by reviewing copies of any Internal Revenue Service form that reports income, such as Form W-2, Form 1099, Schedule K-1 of Form 1065, or a filed Form 1040.",
];

// The retirement account types an investor can pick in the IRA questionnaire. Strings must
// match the `type` values already in use on the investments collection exactly so reporting
// on the admin side stays consistent — do not "clean up" the spelling here in isolation.
// The full set in the data also includes rarer types (Self-Directed Traditional IRA, Trust
// Traditional IRA, Solo 401(k), Qualified Recordkeeping IRA); those are left out to keep the
// list to what investors actually select, and admins can still set them on the record.
export const IRA_INVESTMENT_TYPES = [
  "Traditional IRA",
  "Roth IRA",
  "SEP IRA",
  "Simple IRA",
  "Beneficiary Traditional IRA Account",
  "Beneficiary Roth IRA",
  "HSA",
];

// The custodians an investor can pick on the IRA questionnaire, alphabetical. Derived from
// the custodians investors actually entered while this was a free-text field, so it covers
// the common answers by volume. Deliberately a fixed list rather than a query against the
// custodians collection — that table carries every custodian admin has ever recorded,
// including one-offs and misspellings.
export const IRA_CUSTODIAN_OPTIONS = [
  "Advanta IRA",
  "Alto IRA",
  "American Funds",
  "CamaPlan",
  "Charles Schwab",
  "Chase",
  "Directed IRA",
  "Directed Trust Company",
  "Edward Jones",
  "Empower",
  "Equity Trust Company",
  "eTrade",
  "Fidelity",
  "Forge Trust Co.",
  "Horizon Trust",
  "IRA Club",
  "IRA Financial Trust",
  "Madison Trust",
  "Merrill Lynch",
  "Morgan Stanley",
  "Preferred Trust Company",
  "Solera National Bank",
  "Strata Trust Company",
  "TD Ameritrade",
  "uDirect",
  "Vanguard",
  "Wells Fargo",
];

// Stored as the `custodian` answer when the investor's custodian isn't one of the options
// above. Their typed institution name goes to `retirement_funds_held_at` instead, so
// `custodian` never holds an unrecognized name — anything else in it came from the list.
export const CUSTODIAN_NOT_LISTED_OPTION = "My custodian isn't listed";

export const IRA_QUESTIONNAIRE = [
  {
    question: "Select investment type",
    options: IRA_INVESTMENT_TYPES,
    field_name: "type_of_ira",
  },
  {
    question: "Do you currently have an IRA account?",
    options: [
      { value: true, label: "Yes" },
      { value: false, label: "No" },
    ],
    field_name: "has_ira_account",
  },
  {
    question: "Are you in a self-directed IRA?",
    options: [
      { value: true, label: "Yes" },
      { value: false, label: "No" },
    ],
    field_name: "in_self_directed_ira",
  },
  {
    question:
      "Do you have other Qualified funds you wish to invest (i.e. 401k from a previous employer, etc.)",
    options: [
      { value: true, label: "Yes" },
      { value: false, label: "No" },
    ],
    field_name: "has_other_qualified_funds",
  },
  {
    question: "If you selected Yes to Question 1, please enter the name of your current Custodian",
    field_name: "custodian",
    type: "text",
  },
];

export const STATE_INVESTMENT_LIMITS = {
  Alabama: 0.1,
  Alaska: 0.1,
  Arizona: 0.1,
  Arkansas: 0.1,
  California: 0.1,
  Colorado: 0.1,
  Connecticut: 0.1,
  Delaware: 0.1,
  Florida: 0.1,
  Georgia: 0.1,
  Hawaii: 0.1,
  Idaho: 0.1,
  Illinois: 0.1,
  Indiana: 0.1,
  Iowa: 0.1,
  Kansas: 0.1,
  Kentucky: 0.1,
  Louisiana: 0.1,
  Maine: 0.1,
  Maryland: 0.1,
  Massachusetts: 0.1,
  Michigan: 0.1,
  Minnesota: 0.1,
  Mississippi: 0.1,
  Missouri: 0.1,
  Montana: 0.1,
  Nebraska: 0.1,
  Nevada: 0.1,
  "New Hampshire": 0.1,
  "New Jersey": 0.1,
  "New Mexico": 0.1,
  "New York": 0.1,
  "North Carolina": 0.1,
  "North Dakota": 0.1,
  Ohio: 0.1,
  Oklahoma: 0.1,
  Oregon: 0.1,
  Pennsylvania: 0.1,
  "Rhode Island": 0.1,
  "South Carolina": 0.1,
  "South Dakota": 0.1,
  Tennessee: 0.1,
  Texas: 0.1,
  Utah: 0.1,
  Vermont: 0.1,
  Virginia: 0.1,
  Washington: 0.1,
  "West Virginia": 0.1,
  Wisconsin: 0.1,
  Wyoming: 0.1,
};
export const US_STATES = [
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "District of Columbia",
  "Florida",
  "Georgia",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Puerto Rico",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
];
export const BLOCKED_FILE_EXTENSIONS = [
  ".exe", // Direct executable - VERY dangerous
  ".bat", // Batch script - can execute commands
  ".cmd", // Command script - can execute commands
  ".vbs", // VBScript - can execute arbitrary code
  ".ps1", // PowerShell - very powerful, can do anything
  ".hta", // HTML Application - runs with elevated privileges
  ".scr", // Screensaver executable - basically an .exe
];

export const FIELDS_WITH_ADDITIONAL_INFO = {
  // These only show additional_info when read_only due to signed investment
  first_name: {
    text: "For name, email or SSN/EIN changes, please contact us",
    onlyWhenReadOnly: true,
  },
  last_name: {
    text: "For name, email or SSN/EIN changes, please contact us",
    onlyWhenReadOnly: true,
  },
  email: {
    text: "For name, email or SSN/EIN changes, please contact us",
    onlyWhenReadOnly: true,
  },
  ssn: {
    text: "For name, email or SSN/EIN changes, please contact us",
    onlyWhenReadOnly: true,
  },
  ein: {
    text: "For name, email or SSN/EIN changes, please contact us",
    onlyWhenReadOnly: true,
  },
  // These always show additional_info regardless of read_only state
  current_income: {
    text: "Sources of personal income include money earned from employment, dividends and distributions paid by investments, rents derived from property ownership, and profit sharing from businesses.",
    onlyWhenReadOnly: false,
  },
  current_net_worth: {
    text: "Measured by your assets (checking accounts, savings accounts, retirement savings, real estate, autos, other physical assets, paper assets, or business assets) minus your liabilities (consumer debt, loans, mortgages, other debt). Exclude the net value of your primary residence.",
    onlyWhenReadOnly: false,
  },
  current_liquid_net_worth: {
    text: "Assets measured by available money that is not locked up in long-term investments or physical objects. These can include checking accounts, savings accounts, money market accounts, certificates of deposit, stocks, ETFs, mutual funds, and bonds. Liquid Net Worth is the combination of the above minus your liabilities (consumer debt, loans, mortgages, other debt).",
    onlyWhenReadOnly: false,
  },
};

export const PURCHASE_FLOW_INFO = {
  Amount: {
    title: "Choosing your investment amount",
    items: [
      {
        label: "Minimum investment",
        description:
          "Regulation D offerings require a minimum investment of $25,000. Registered Offering (S1) offerings require a minimum of $5,000. If you've already completed a signed investment, you can add to that same offering in increments of $1,000.",
      },
      {
        label: "You can change this later",
        description:
          "If you need to adjust your amount before signing, you can do so from the review step. Changing the amount after signing requires a new subscription agreement.",
      },
      {
        label: "Reinvestment",
        description:
          "If you have an investment nearing maturity that is eligible for reinvestment, you may apply some or all of that balance toward your new investment instead of funding it with new money.",
      },
    ],
  },

  "Payment Frequency": {
    title: "How would you like to receive returns?",
    items: [
      {
        label: "Interest Paid Monthly",
        description:
          "You'll receive interest payouts every month during the term of your investment. Your original investment amount (principal) is returned at the end of the term. Best if you want regular income or predictable cash flow.",
      },
      {
        label: "Compounded Monthly",
        description:
          "Both your interest and original investment are paid together when the investment term ends. No monthly payouts along the way. Best if you're focused on long-term growth and don't need income right now.",
      },
      {
        label: "Why we ask this",
        description:
          "Your preference helps us structure the investment correctly and ensure payouts align with how you want to receive returns.",
      },
    ],
  },

  "Term and Yield": {
    title: "Understanding term and interest rate",
    items: [
      {
        label: "What is the term?",
        description:
          "The term is the length of time your investment is held before it matures. Longer terms typically offer higher interest rates because your capital is committed for a longer period.",
      },
      {
        label: "What is the interest rate?",
        description:
          "The interest rate (APR) is the annual rate of return you'll earn on your investment. This rate is fixed for the duration of the term you select, so your return is predictable from day one.",
      },
      {
        label: "Choosing the right fit",
        description:
          "Consider your liquidity needs and financial goals. If you may need access to your funds sooner, a shorter term may be more appropriate. If you can commit for longer, a higher interest rate may be available.",
      },
    ],
  },

  "Investment Type": {
    title: "Types of investments",
    items: [
      {
        label: "Individual",
        description:
          "A standard investment held in your name only. This is the simplest option and is appropriate for most investors.",
      },
      {
        label: "Joint",
        description:
          "An investment held by two individuals. Both parties will need to provide personal information, and both are required to sign a subscription agreement.",
      },
      {
        label: "Entity",
        description:
          "An investment made on behalf of a legal entity such as an LLC, trust, or corporation. You'll need to provide entity details and identify beneficial owners.",
      },
      {
        label: "IRA",
        description:
          "An investment held within an Individual Retirement Account. Additional custodian information will be required, and funding is handled through your IRA provider.",
      },
    ],
  },

  "Personal Information": {
    title: "Your personal information",
    items: [
      {
        label: "Why we collect this",
        description:
          "Federal regulations require us to verify your identity before processing an investment. The information you provide is used for identity verification and to prepare your subscription agreement.",
      },
      {
        label: "Locked fields",
        description:
          "If you've previously completed a signed investment, certain fields like your name, email, and SSN are locked to maintain consistency across your account. Contact support if you need to update these.",
      },
      {
        label: "Your data is protected",
        description:
          "Sensitive information such as your Social Security number is encrypted and stored securely. It is only used for regulatory compliance and is never shared with third parties for marketing purposes.",
      },
    ],
    substeps: {
      "Personal Information": {
        title: "Basic personal details",
        items: [
          {
            label: "What we need",
            description:
              "Your legal first name, last name, date of birth, and contact information. Please use the name that matches your government-issued ID.",
          },
          {
            label: "Why accuracy matters",
            description:
              "This information is used on your subscription agreement and for identity verification. Mismatches between your name here and your ID can cause processing delays.",
          },
        ],
      },
      "Residentials Address": {
        title: "Residential address",
        items: [
          {
            label: "Primary residence",
            description:
              "Enter the address where you currently reside. This is required for regulatory purposes and will appear on your subscription agreement.",
          },
          {
            label: "P.O. Boxes",
            description:
              "A P.O. Box cannot be used as your residential address. If your mailing address differs from your residential address, you'll be able to provide it in the next step.",
          },
        ],
      },
      "Mailing Address": {
        title: "Mailing address",
        items: [
          {
            label: "When to provide a separate mailing address",
            description:
              "If you receive mail at a different address than where you live — such as a P.O. Box or office — enter it here. Otherwise, you can indicate that your mailing address is the same as your residential address.",
          },
        ],
      },
      "ID Information": {
        title: "Identification details",
        items: [
          {
            label: "Government-issued ID",
            description:
              "Enter your ID number, the issuing authority, the issue date, and the expiration date. This is typically your driver's license or state-issued ID card.",
          },
          {
            label: "Why we need this",
            description:
              "Your identification details are required for identity verification and are standard for investment accounts. Make sure the information matches your physical ID exactly.",
          },
        ],
      },
    },
  },

  "Suitability Questionnaire": {
    title: "Suitability questionnaire",
    items: [
      {
        label: "Why we ask these questions",
        description:
          "Securities regulations require us to assess whether an investment is suitable for you based on your financial situation, experience, and goals. Your answers help ensure this investment aligns with your needs.",
      },
      {
        label: "Some answers may prevent you from continuing",
        description:
          "Certain responses indicate the investment may not be appropriate for you. For example, selecting a conservative risk tolerance or a time horizon shorter than the offering term will require you to update your selection before proceeding.",
      },
      {
        label: "Your answers are confidential",
        description:
          "Suitability information is used solely for regulatory compliance and is not shared externally.",
      },
    ],
    substeps: {
      "Income Information": {
        title: "Income and net worth",
        items: [
          {
            label: "What to include",
            description:
              "Report your current income and liquid net worth (assets that can be quickly converted to cash). Include salary, investment income, and other regular sources of income.",
          },
          {
            label: "Why this matters",
            description:
              "Regulators require this information to help determine whether the investment amount is appropriate relative to your overall financial picture.",
          },
          {
            label: "Registered Offering (S1) financial requirements",
            description:
              "If you're investing in a Registered Offering (S1), you must meet one of the following: both your current income and liquid net worth are each at least $70,000, or your liquid net worth alone is at least $250,000. If these thresholds aren't met, you won't be able to continue with a Registered Offering (S1).",
          },
        ],
      },
      Questionnaire: {
        title: "Investment experience and risk tolerance",
        items: [
          {
            label: "Investment objectives",
            description:
              "Select the objective that best describes what you're looking for. Note that capital preservation-focused objectives are not compatible with this type of investment.",
          },
          {
            label: "Risk tolerance",
            description:
              'The SEC considers all Regulation D offerings to be speculative regardless of whether they are equity or fixed income. You\'ll need to indicate a risk tolerance of "Significant" or "Speculative" to continue.',
          },
          {
            label: "Time horizon",
            description:
              "Your investment time horizon must align with the term of the offering you've selected. If the offering term is longer than the time horizon you select, you'll need to adjust your selection.",
          },
          {
            label: "Acknowledgement questions",
            description:
              'Several questions ask you to confirm your understanding of investment risks and your responsibility for the investment decision. These require a "Yes" response to proceed.',
          },
        ],
      },
    },
  },

  "Joint Information": {
    title: "Joint investment details",
    items: [
      {
        label: "What is a joint investment?",
        description:
          "A joint investment is held by two individuals who share ownership. Both parties have rights to the investment and both may need to sign the subscription agreement.",
      },
      {
        label: "Joint contact requirements",
        description:
          "The joint contact must provide their own personal information, residential address, and identification. This is required for regulatory compliance and identity verification.",
      },
      {
        label: "Selecting an existing contact",
        description:
          "If you've previously added a joint contact, you can select them from the list to avoid re-entering their information.",
      },
    ],
    substeps: {
      "Joint Contact Selection": {
        title: "Select or add a joint contact",
        items: [
          {
            label: "Existing joint contacts",
            description:
              "If you've invested jointly before, your previous joint contact will appear here. Select them to pre-fill their information.",
          },
          {
            label: "Adding a new contact",
            description:
              "If this is your first joint investment or you'd like to invest with a different person, you can enter their details in the following steps.",
          },
        ],
      },
      "Joint Information": {
        title: "Joint contact personal details",
        items: [
          {
            label: "Legal name required",
            description:
              "Enter the joint contact's full legal name as it appears on their government-issued ID.",
          },
          {
            label: "Contact information",
            description:
              "A valid email address is required for the joint contact. They may receive a separate signature request via email.",
          },
        ],
      },
      "Residential Address": {
        title: "Joint contact address",
        items: [
          {
            label: "Residential address",
            description:
              "Enter the joint contact's current residential address. This is required for identity verification and cannot be a P.O. Box.",
          },
        ],
      },
      "ID Information": {
        title: "Joint contact identification",
        items: [
          {
            label: "Identity verification",
            description:
              "The joint contact's ID information is required for the same regulatory reasons as your own. Enter their ID number, issuing authority, issue date, and expiration date.",
          },
          {
            label: "Data security",
            description:
              "Their sensitive information is encrypted and protected with the same security standards applied to your own.",
          },
        ],
      },
    },
  },

  "Entity Information": {
    title: "Entity investment details",
    items: [
      {
        label: "What qualifies as an entity?",
        description:
          "Entities include LLCs, corporations, partnerships, trusts, and other legally recognized organizations. The entity must be in good standing and authorized to make investments.",
      },
      {
        label: "Beneficial owners",
        description:
          "Federal regulations require disclosure of individuals who own or control 25% or more of the entity, as well as at least one individual with significant control (such as a managing member or officer).",
      },
      {
        label: "EIN required",
        description:
          "You'll need the entity's Employer Identification Number (EIN) for tax reporting purposes.",
      },
    ],
    substeps: {
      "Entity Selection": {
        title: "Select or add an entity",
        items: [
          {
            label: "Existing entities",
            description:
              "If you've previously invested through an entity, it will appear here. Select it to pre-fill entity details.",
          },
          {
            label: "New entity",
            description:
              "If this is your first entity investment, you'll provide entity details in the following steps.",
          },
        ],
      },
      "Entity Information": {
        title: "Entity details",
        items: [
          {
            label: "Entity name and type",
            description:
              "Enter the entity's legal name exactly as registered. Select the entity type (LLC, Trust, Corporation, etc.) from the available options.",
          },
          {
            label: "EIN",
            description:
              "The entity's Employer Identification Number is required for tax reporting. This is encrypted and stored securely.",
          },
        ],
      },
      "Entity Address": {
        title: "Entity address",
        items: [
          {
            label: "Principal place of business",
            description:
              "Enter the entity's primary business address. This will appear on the subscription agreement and related documents.",
          },
        ],
      },
      "Beneficial Owners": {
        title: "Beneficial owners",
        items: [
          {
            label: "Who must be listed?",
            description:
              "Under federal anti-money-laundering rules, you must identify each individual who directly or indirectly owns 25% or more of the entity, plus at least one person with significant managerial control.",
          },
          {
            label: "Using existing contacts",
            description:
              "You or your joint contact can be designated as beneficial owners if applicable. You can also add new individuals who aren't already in the system.",
          },
          {
            label: "Accuracy is important",
            description:
              "Beneficial ownership information is verified as part of regulatory compliance. Ensure the information provided is current and accurate.",
          },
        ],
      },
    },
  },

  Accreditation: {
    title: "Accreditation verification",
    items: [
      {
        label: "What is an accredited investor?",
        description:
          "An accredited investor meets certain income or net worth thresholds defined by the SEC. Regulation D offerings are limited to accredited investors, which is why verification is required.",
      },
      {
        label: "How to qualify",
        description:
          "Common qualification criteria include: annual income over $200,000 (or $300,000 jointly) in each of the last two years, or net worth exceeding $1 million excluding your primary residence.",
      },
      {
        label: "Supporting documents",
        description:
          "You may be asked to upload documents such as tax returns, brokerage statements, or a letter from a licensed professional verifying your accredited status.",
      },
    ],
    substeps: {
      Acknowledgements: {
        title: "Accreditation acknowledgements",
        items: [
          {
            label: "What you're acknowledging",
            description:
              "You'll confirm which accreditation criteria you meet. These acknowledgements become part of your subscription agreement and are subject to regulatory review.",
          },
          {
            label: "Entity accreditation",
            description:
              "If investing through an entity, the entity itself must meet accreditation criteria. The specific acknowledgements differ from individual accreditation.",
          },
        ],
      },
      "Upload Documents": {
        title: "Accreditation documents",
        items: [
          {
            label: "What to upload",
            description:
              "Accepted documents include recent tax returns, W-2s, brokerage or bank statements, or a verification letter from a CPA, attorney, or licensed broker-dealer.",
          },
          {
            label: "Document handling",
            description:
              "Uploaded documents are stored securely and reviewed by our compliance team. They are not shared externally and are used solely to verify your accredited investor status.",
          },
        ],
      },
    },
  },

  "Funding and Distribution": {
    title: "Funding and distribution",
    items: [
      {
        label: "Funding your investment",
        description:
          "Choose how you'll send funds to complete your investment. Options include ACH transfer from a linked bank account, wire transfer, check, or applying an existing maturing investment.",
      },
      {
        label: "Receiving distributions",
        description:
          "Select how you'd like to receive interest payments and your principal at maturity. You can choose ACH deposit to a bank account, check, or compounding bonds if you've elected interest paid at maturity.",
      },
      {
        label: "Linking a bank account",
        description:
          "If you select ACH, you'll securely connect a bank account through Plaid. Your banking credentials are never stored — Plaid handles authentication directly with your bank.",
      },
    ],
    substeps: {
      "Funding your investment": {
        title: "Funding your investment",
        items: [
          {
            label: "ACH transfer",
            description:
              "Link a bank account securely through Plaid for electronic transfer. This is the fastest and most common funding method.",
          },
          {
            label: "Wire transfer",
            description:
              "Wire instructions will be provided after you complete the subscription agreement. Wires are typically processed within 1–2 business days.",
          },
          {
            label: "Check",
            description:
              "If you prefer to pay by check, mailing instructions will be provided. Please allow additional processing time for check payments.",
          },
          {
            label: "Existing investment",
            description:
              "If you're rolling over a maturing investment, the funds from that investment will be applied automatically. No additional funding action is needed on your part.",
          },
        ],
      },
      Distribution: {
        title: "Receiving returns for your investment",
        items: [
          {
            label: "ACH deposit",
            description:
              "Link a bank account to receive payments electronically. You can use the same account as your funding source or a different one.",
          },
          {
            label: "Check",
            description:
              "Distribution checks will be mailed to the address on file. Allow additional processing and delivery time compared to ACH.",
          },
          {
            label: "Compounding bonds",
            description:
              "If you've elected to have interest and principal paid at maturity, you can select compounding bonds. Your interest accrues and is paid out together with your principal when the investment matures — no distributions are issued during the term.",
          },
        ],
      },
    },
  },

  "IRA Details": {
    title: "IRA investment details",
    items: [
      {
        label: "How IRA investments work",
        description:
          "When investing through an IRA, the investment is held by your IRA custodian on your behalf. Funding and distributions are handled through the custodian, not directly to or from your personal bank account.",
      },
      {
        label: "Custodian information",
        description:
          "You'll need to provide the name of your IRA custodian and your account number. If you don't have a self-directed IRA yet, we can provide guidance on setting one up.",
      },
      {
        label: "Self-directed IRA required",
        description:
          "This type of investment typically requires a self-directed IRA, which allows alternative investments beyond traditional stocks and bonds. Not all IRA providers support self-directed accounts.",
      },
    ],
  },

  "Review and Sign": {
    title: "Review and sign",
    items: [
      {
        label: "Review your details",
        description:
          "Before signing, carefully review all investment details, personal information, and selections. You can go back to any previous step to make corrections if needed.",
      },
      {
        label: "Subscription agreement",
        description:
          "The subscription agreement is the legal document that formalizes your investment. By signing, you confirm that all information provided is accurate and that you understand the terms of the offering.",
      },
      {
        label: "Electronic signature",
        description:
          "Your signature is collected electronically and is legally binding. The signing link is generated securely and is time-sensitive — if it expires, a new one can be generated.",
      },
      {
        label: "What happens next",
        description:
          "After signing, your investment moves to a pending status for processing. You'll receive a confirmation and can track the status of your investment from the investments page.",
      },
    ],
  },
};

export const CHANGE_INVESTMENT_INFO = {
  "Change Investment": {
    title: "Setting up your conversion",
    items: [
      {
        label: "What is a conversion?",
        description:
          "A conversion allows you to move the value of an existing investment — including any accrued interest — into one or more new investments with different terms. Your current investment is not canceled; its value is reallocated.",
      },
      {
        label: "Registered offerings only",
        description:
          "Conversions are currently available only into our Registered Offering (S1). Other offering types are not eligible as conversion targets at this time.",
      },
      {
        label: "Splitting your investment",
        description:
          "You can split your investment's value across multiple new investments, each with a different term or interest type (monthly vs. at maturity). Each split must be in increments of $1,000, and the total must equal the full investable value of your current bonds.",
      },
      {
        label: "Term restrictions",
        description:
          "You can only convert into an equal or longer term than your current investment — shorter terms are not available. Each split must also have a unique combination of term and interest type.",
      },
    ],
  },

  "Suitability Questionnaire": {
    title: "Suitability questionnaire",
    items: [
      {
        label: "Why we ask these questions",
        description:
          "Securities regulations require us to assess whether an investment is suitable for you based on your financial situation, experience, and goals. Your answers help ensure this investment aligns with your needs.",
      },
      {
        label: "Some answers may prevent you from continuing",
        description:
          "Certain responses indicate the investment may not be appropriate for you. For example, selecting a conservative risk tolerance or a time horizon shorter than the offering term will require you to update your selection before proceeding.",
      },
      {
        label: "Your answers are confidential",
        description:
          "Suitability information is used solely for regulatory compliance and is not shared externally.",
      },
    ],
    substeps: {
      "Income Information": {
        title: "Income and net worth",
        items: [
          {
            label: "What to include",
            description:
              "Report your current income and liquid net worth (assets that can be quickly converted to cash). Include salary, investment income, and other regular sources of income.",
          },
          {
            label: "Why this matters",
            description:
              "Regulators require this information to help determine whether the investment amount is appropriate relative to your overall financial picture.",
          },
          {
            label: "Registered Offering (S1) financial requirements",
            description:
              "If you're investing in a Registered Offering (S1), you must meet one of the following: both your current income and liquid net worth are each at least $70,000, or your liquid net worth alone is at least $250,000. If these thresholds aren't met, you won't be able to continue with a Registered Offering (S1).",
          },
        ],
      },
      Questionnaire: {
        title: "Investment experience and risk tolerance",
        items: [
          {
            label: "Investment objectives",
            description:
              "Select the objective that best describes what you're looking for. Note that capital preservation-focused objectives are not compatible with this type of investment.",
          },
          {
            label: "Risk tolerance",
            description:
              'The SEC considers all Regulation D offerings to be speculative regardless of whether they are equity or fixed income. You\'ll need to indicate a risk tolerance of "Significant" or "Speculative" to continue.',
          },
          {
            label: "Time horizon",
            description:
              "Your investment time horizon must align with the term of the offering you've selected. If the offering term is longer than the time horizon you select, you'll need to adjust your selection.",
          },
          {
            label: "Acknowledgement questions",
            description:
              'Several questions ask you to confirm your understanding of investment risks and your responsibility for the investment decision. These require a "Yes" response to proceed.',
          },
        ],
      },
    },
  },
  "Sign and Finalize": {
    title: "Finalize your conversion",
    items: [
      {
        label: "Review your changes",
        description:
          "A summary of your conversion is displayed for review, including each new investment's term, interest type, and amount. Make sure everything looks correct before proceeding.",
      },
      {
        label: "Subscription agreements",
        description:
          "Each investment in your conversion requires its own subscription agreement. If you've split into multiple investments, you'll sign a separate agreement for each one.",
      },
      {
        label: "Conversion agreement",
        description:
          "In addition to the subscription agreements, you'll sign a Conversion Request Form that authorizes the reallocation of your current investment's value into the new investments.",
      },
      {
        label: "Electronic signature",
        description:
          "All signatures are collected electronically and are legally binding. Your conversion will be finalized once every agreement has been signed.",
      },
    ],
  },
};

export const S1_QUIET_PERIOD_INFO = {
  title: "Registered Offering (S1) — Quiet Period",
  items: [
    {
      label: "What is a quiet period?",
      description:
        "A quiet period occurs when legal or regulatory updates are being made to the Registered Offering (S1). During this time, new signatures cannot be collected, but investments and payments can still be submitted.",
    },
    {
      label: "You can still invest during this period",
      description:
        "While the quiet period is active, you can complete the investment flow and submit your payment. Your signature and final documentation will be collected once the quiet period concludes.",
    },
    {
      label: "What happens after you invest",
      description:
        "Once the quiet period ends, we'll notify you that your investment is ready to finalize. At that point, you'll return to sign your subscription agreement and complete the process.",
    },
    {
      label: "Your information is saved",
      description:
        "All the details you provide during the investment process are saved securely. When signing becomes available, you'll pick up right where you left off without re-entering anything.",
    },
  ],
};

// Grouped sub-steps for the paginated Suitability Questionnaire. Order defines the
// sub-step sequence. `renderer: "form"` renders the income/financial fields via Form;
// `renderer: "questionnaire"` renders that group's radio questions via SuitabilityQuestionnaire.
// Questionnaire fields not listed in any group fall into the LAST questionnaire group so
// nothing is ever dropped when the backend schema changes.
export const SUITABILITY_QUESTIONNAIRE_GROUPS = [
  { name: "Financial Profile", renderer: "form" },
  {
    name: "Investment Goals & Experience",
    renderer: "questionnaire",
    fields: [
      "investment_objective",
      "investment_experience",
      "investment_time_horizon",
      "risk_willingness",
    ],
  },
  {
    name: "Portfolio & Allocations",
    renderer: "questionnaire",
    fields: [
      "equities_allocation",
      "bonds_allocation",
      "real_estate_allocation",
      "other_investments_allocation",
      "overall_portfolio_percentage",
    ],
  },
  {
    name: "Risk & Employment",
    renderer: "questionnaire",
    fields: [
      "significant_liquid_net_worth",
      "risky_investment_understanding",
      "employment_status",
      "employed_by_security_or_financial_regulatory",
    ],
  },
];
